<script lang="ts">
    import type {Conjunction, Criterion} from 'src/features/search/search-criteria/criteria.types';
    import type {SearchManagerState} from 'src/features/search/search-manager/search-manager';
    import type CriterionMarshaller from 'src/features/search/search-criteria/criterion-marshallers/criterion-marshaller';
    import {exists, identifiedValuesEquals} from 'shared/utils/custom-utils';
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';
    import KpDropdownMenuWrapper from 'shared/ui-widgets/dropdown-menu/KpDropdownMenuWrapper.svelte';
    import SearchToolbarFacetEditor from 'src/features/search/kp-search-toolbar/SearchToolbarFacetEditor.svelte';

    export let criterion: Criterion;
    export let searchManagerState: SearchManagerState;
    export let criterionMarshaller: CriterionMarshaller;

    function isFacetActive(criterionsToCompare: Criterion[], conjunction: Conjunction | null): boolean {
        if (!exists(conjunction)) {
            return false;
        }

        const filledCriterions = criterionMarshaller.fromConjunctionToCriterions(searchManagerState.frontendParams.facetRestriction);
        return filledCriterions.some((filledCriterion) => criterionsToCompare.some((comparedCriterion) => identifiedValuesEquals(comparedCriterion.field, filledCriterion.field)));
    }
</script>

<KpDropdownMenuWrapper additionalMenuClasses="toolbar-facets-dropdown-menu">
    <span class="facet-name"
          slot="button"
          class:facet-selected={isFacetActive([criterion], searchManagerState.frontendParams.facetRestriction)}>

        {pipe(criterion.field, loc())}
    </span>

    <svelte:fragment slot="menu">
        <SearchToolbarFacetEditor {criterion} on:criterion-change/>
    </svelte:fragment>
</KpDropdownMenuWrapper>

<style lang="less">
    .facet-selected {
        font-weight: 500;
        text-decoration: underline;
        color: var(--accent-blue);
    }

    .facet-name {
        white-space: nowrap;
    }

    :global {
        .toolbar-facets-dropdown-menu .kp-dropdown-wrapper .dropdown-wrapper-button {
            align-items: unset !important
        }
    }
</style>